import React from 'react'

import { useNavigate } from 'react-router-dom'

import './HomeAbout.css'

function HomeAbout() {

  let navigate = useNavigate()


  return (
    <div className='homeAbout'>
      <div className='section__container'>
        <div className='section'>
          <div className='homeAbout_section'>
            <div className='hac__left'>
              <h1 className='section__header' data-aos="fade-up">About the Department</h1>
              <p className='about__p' data-aos="fade-up">
                The Computer Engineering Department offers both Undergraduate and Postgraduate courses. The Undergraduate Computer Science & Engineering programme of Government Model Engineering College is ranked among the best technical programs in the country. The department offers a four-year course, at the end of which the student receives a Bachelor of Technology degree in Computer Science & Engineering from APJ Abdul Kalam Technological University. The program imparts an outstanding educational opportunity for those planning to pursue a career or to gain in-depth knowledge in computing technology and research.
              </p>
              <p className='about__p' data-aos="fade-up">
                Keeping in pace with the IT era, the Computer Science & Engineering syllabus covers an exhaustive realm of core fields like Operating Systems, Compiler Design etc. The Computer Labs are distinguished along the lines of the Platforms and Operating Systems used. There is a general Computing Lab for beginners, a UNIX Lab with scores of terminals and finally, an Advanced Computing Lab that houses some of the best hardware and software in the Industry.
              </p>
              <p className='about__p' data-aos="fade-up">
                The college also offers a Post Graduation course in Computer Science and Engineering with a specialization in Image Processing.
              </p>
            </div>
            <div className='hac__right' data-aos="fade-left">
              <div className='homeAbout__img_outline' />
              <img className='homeAbout__img' src='https://res.cloudinary.com/meccs/image/upload/v1660708280/Assets/banner5_kahyvg.jpg' alt='' />
            </div>
          </div>
        </div>
        <div className='section'>
          <div className='homeAbout_button'>
            <button onClick={() => navigate('about')}>Our Vision and Mission</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeAbout